import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAxios
 from '../../axios/useAxios';
import { ACCOUNT, BRAND } from '../../constants/routes';
import PageLoader from '../../components/loader/PageLoader';
import ScanFooter from '../account/ScanFooter';
import BrandList from './BrandList';
import BackButton from '../../components/button/BackButton';
const BrandPartnerScreen = () => {
  const axiosInstance = useAxios();
  const navigate = useNavigate();

  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get('/brands')
      .then((response) => {
        setBrands(response.data);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const pikkoBrandOfferText = (
    currentBrand,
  ) => `Pour chaque euro dépensé dans les produits de la gamme ${currentBrand.name}, 
  récupère ${currentBrand.fidelityConversionRate} Pikoin(s).`;

  return (
    <div id="brand-partner-screen">
      <div className="brand-partner-screen-body">
        {!isLoading ? (
          <div className="brand-partner-content">
            <BackButton onClick={() => navigate(ACCOUNT)} />
            <div className="brand-partner-title">Nos partenaires</div>
            <BrandList brands={brands} originPath={BRAND} />
          </div>
        ) : (
          <PageLoader />
        )}
      </div>
      <ScanFooter originPath={BRAND} />
    </div>
  );
};

export default BrandPartnerScreen;
